import React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {selectError} from '../../selectors/commonSelector';
import {RootMachineContext} from '../../machines/rootMachine/rootMachine.context';

import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {ErrorMessage} from '@spaced-out/ui-design-system/lib/components/ErrorMessage';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa/qa';
import {TEST_ID} from '../../utils/testId';


export const ErrorPage = () => {
  const {t} = useLabelTranslation();
  const rootMachine = RootMachineContext.useActorRef();

  const {errorMessage, allowRetry} = RootMachineContext.useSelector((state) =>
    selectError(state, t),
  );

  const onRetry = () => {
    rootMachine.send({type: 'retry'});
  };

  return (
    <ErrorMessage
      imageVariant="serverError"
      // already translated in errorMessage
      // eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels
      title={errorMessage}
      {...(allowRetry && {
        description: t(
          'We_couldn\'t_load_the_meeting_details_Please_try_again',
          'We couldn\'t load the meeting details. Please try again',
        ),
      })}
    >
      {allowRetry && (
        <Button
          onClick={onRetry}
          testId={generateTestId({base: TEST_ID.ERROR_PAGE})}
        >
          {t('Retry', 'Retry')}
        </Button>
      )}
    </ErrorMessage>
  );
};
